import { useEffect } from "react";
import ApplyForAdmission from "../components/ApplyForAdmission";
import Breadcrumb from "../components/Breadcrumb";
import FooterThree from "../components/FooterThree";
import HeaderOne from "../components/HeaderOne";
import { useLoader } from "../context/LoaderContext";
import Animation from "../helper/Animation";
import Preloader from "../helper/Preloader";
import { fetchCompanyDetails } from "../api/CompanyDetailsApi";
import { useAllDataContext } from "../context/AllDataContext";
import { FetchAllApi } from "../components/FetchAllApi";
import PrivacyPolicyInner from "../components/PrivacyPolicyInner";
import { useLocation } from "react-router-dom";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";

const ApplyAdmissionPage = () => {
  const { setLoading } = useLoader();
  const { companyDetailsData, setCompanyDetailsData } =
    useCompanyDetailsContext();
  const { allData, setAllData } = useAllDataContext();
  const location = useLocation();

  const policiesData = allData.policiesData;

  const section = location.state?.section;
  const admissionBannerData = allData.allBannerData[0]?.admission_title;

  useEffect(() => {
    if (section) {
      const el = document.getElementById(section.toLowerCase());
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [section]);

  FetchAllApi({ companyDetailsData, setAllData, setLoading });

  useEffect(() => {
    if (companyDetailsData.length === 0) {
      Promise.all([fetchCompanyDetails()])
        .then(([companyDetailsData]) => {
          setCompanyDetailsData(companyDetailsData);
        })
        .catch(() => {
          console.error("Server Error");
        });
    }
  }, [companyDetailsData.length, setCompanyDetailsData]);
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* Animation */}
      <Animation />

      {/* HeaderTwo */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb heading={admissionBannerData} title={"Admission"} />

      {/* PrivacyPolicyInner */}
      <PrivacyPolicyInner policiesData={policiesData} />

      {/* ApplyForAdmission */}
      {/* <ApplyForAdmission municipalityOption={municipalityOption} /> */}
      <ApplyForAdmission />

      {/* CertificateOne */}
      {/* <CertificateOne /> */}

      {/* FooterOne */}
      <FooterThree />
    </>
  );
};

export default ApplyAdmissionPage;
